import { MatchingType } from '../../types/EquipmentTypes';

export default {
  title: 'Automation',
  items: [
    {
      title: 'Alarm Monitoring System',
      hasMaker: true,
      hasType: true,
      makers: [
        'Kongsberg',
        'Yokogawa',
        'Hoglund',
        'Wartsila',
        'NorControl',
        'Hyundai',
        'Lyngso',
        'Terasaki',
        'Bemac',
        'JRCS',
      ],
      standardServices: [
        {
          title: 'Control System Troubleshooting/Repair',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'ECR Console',
      hasMaker: true,
      hasType: true,
      makers: [
        'Nabtesco',
        'Lyngso',
        'Taiyo',
        'Hyundai',
        'Wartsila',
        'Kongsberg',
        'Terasaki',
        'Sam Eas',
        'Bemac',
        'JRCS',
      ],
      standardServices: [
        {
          title: 'Control System Troubleshooting/Repair',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'Engine Room Temperature Controllers',
      hasMaker: true,
      hasType: true,
      makers: ['Nakakita', 'ASCO', 'Korval Co'],
      standardServices: [
        {
          title: 'Control System Troubleshooting/Repair',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'Main Engine Telegraph System',
      hasMaker: true,
      hasType: true,
      makers: [
        'Kongsberg',
        'Wartsila',
        'Lyngso',
        'NorControl',
        'Berg Propulsion',
        'Nabtesco',
        'Mitsui',
      ],
      standardServices: [
        {
          title: 'Control System Troubleshooting/Repair',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'Pressure & Temperature Calibrators',
      hasMaker: true,
      hasType: true,
      makers: [],
      standardServices: [
        {
          title: 'Calibration',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'Remote Controlled Valves',
      hasMaker: true,
      hasType: false,
      makers: [
        'Westad',
        'Korval',
        'KSB',
        'S&S Valves',
        'S.N.R.I.',
        'Nabtesco',
        'Rotork',
        'Ampo Poyam',
        'AEV',
        'Emerson',
        'Hanla',
        'Hoppe Marine',
        'Scana',
        'A-T Controls',
        'Nakakita',
        'Keystone Valves',
        'Damcos',
      ],
      standardServices: [
        {
          title: 'Hydraulic Repairs',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Control System Troubleshooting/Repair',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'Tank Level/Draft Gauging System',
      hasMaker: true,
      hasType: true,
      makers: [
        'Hanla',
        'Hoppe Marine',
        'Jowa',
        'Emerson',
        'Kongsberg',
        'Panasia',
        'Musasino',
        'Enraf',
        'Tokyo Keiki',
      ],
      standardServices: [
        {
          title: 'Control System Troubleshooting/Repair',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'Viscometer',
      hasMaker: true,
      hasType: true,
      makers: [
        'VAF',
        'Emerson',
        'Nakakita',
        'Saginomiya Seisakusho',
        'Auramarine',
      ],
      standardServices: [
        {
          title: 'Control System Troubleshooting/Repair',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
  ],
};
